import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import { Step } from "./MfaByEmail.types";
import { sendEmailWithSdk, sendMfaCode } from "../../api/sdk.api";
import { getMfaToken } from '@chegg/one-auth-sdk';
import { handleError } from "../../utils/mfaErrorHandler";
import { useSetFpEnv } from "../../lib/hooks/useSeFpEnv";
import SendEmail from "../SendEmail";
import ValidateCode from "../ValidateCode";
import { EventTypes, recordEvents } from "../../utils/newRelicEvents";
import { getTexts } from "../../config/texts";
import { interactionRioEvent, successRioEvent } from "../../lib/rio";
import { Popup } from "../styles";
var MfaByEmail = function MfaByEmail(props) {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    mfaToken = _useState2[0],
    setMfaToken = _useState2[1];
  var _useState3 = useState(Step.SendEmail),
    _useState4 = _slicedToArray(_useState3, 2),
    currentStep = _useState4[0],
    setCurrentStep = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoading = _useState8[0],
    setIsLoading = _useState8[1];
  var _useState9 = useState(null),
    _useState10 = _slicedToArray(_useState9, 2),
    errorMessage = _useState10[0],
    setErrorMessage = _useState10[1];
  var onSuccessCb = props.onSuccessCb,
    userUuid = props.userUuid,
    clientId = props.clientId,
    hideCloseButton = props.hideCloseButton,
    onErrorCb = props.onErrorCb;
  var _useState11 = useState(props.email),
    _useState12 = _slicedToArray(_useState11, 2),
    email = _useState12[0],
    setEmail = _useState12[1];
  var texts = getTexts();
  useSetFpEnv();
  useEffect(function () {
    if (props.mfaToken) {
      setMfaToken(props.mfaToken);
    } else {
      getMfaToken(clientId)["catch"](function (e) {
        if (e.mfaPayload) {
          setMfaToken(e.mfaPayload.mfa_token);
          setEmail(e.mfaPayload.email);
          return;
        }
        if (onErrorCb) {
          onErrorCb(new Error('failed to get mfa token from downstream server'));
        }
        setErrorMessage(texts.errorMessages.downstream_server_issue);
      });
    }
  }, [props.mfaToken, clientId, onErrorCb]);
  var goBack = function goBack() {
    interactionRioEvent({
      interaction: {
        type: 'click',
        element: {
          type: 'link',
          name: 'request new code',
          region_name: 'mfa request new code in validate code modal',
          text: texts.validateCodeText.footerSendAgain
        }
      }
    });
    /* istanbul ignore next */
    if (errorMessage) {
      setErrorMessage(null);
    }
    setCurrentStep(Step.SendEmail);
  };
  var sendCodeToEmail = async function sendCodeToEmail() {
    setIsLoading(true);
    setErrorMessage(null);
    try {
      recordEvents(_defineProperty({}, EventTypes.sendEmailStart, {}));
      await sendEmailWithSdk(mfaToken);
      setCurrentStep(Step.ValidateCode);
      recordEvents(_defineProperty({}, EventTypes.sendEmailEnd, {}));
      setIsLoading(false);
    } catch (e) {
      var _errorMessage = handleError(e, EventTypes.sendEmailFail);
      setErrorMessage(_errorMessage);
      setIsLoading(false);
      if (onErrorCb) {
        onErrorCb(e);
      }
    }
  };
  var sendMfaValidationCode = async function sendMfaValidationCode(code) {
    setIsLoading(true);
    if (props.onLoadingCb) props.onLoadingCb();
    try {
      recordEvents(_defineProperty({}, EventTypes.validateCodeStart, {
        user_uuid: userUuid
      }));
      var tokens = await sendMfaCode(userUuid, mfaToken, code);
      successRioEvent({
        name: 'mfa verification success',
        state: 'complete'
      });
      recordEvents(_defineProperty({}, EventTypes.validateCodeEnd, {
        user_uuid: userUuid
      }));
      setIsLoading(false);
      onSuccessCb(tokens);
    } catch (e) {
      var _errorMessage2 = handleError(e, EventTypes.validateCodeFail);
      setErrorMessage(_errorMessage2);
      setIsLoading(false);
      if (onErrorCb) {
        onErrorCb(e);
      }
    }
  };
  var closeMfa = function closeMfa() {
    if (props.onMfaClose) {
      /* istanbul ignore next cant figure out how to trigger this since I cant target the "x" button */
      var response = errorMessage && errorMessage === texts.errorMessages.expired_token ? true : false;
      props.onMfaClose(response);
    }
    setIsOpen(false);
  };
  var clearErrorMessage = function clearErrorMessage() {
    setErrorMessage(null);
  };
  var renderSendEmail = function renderSendEmail() {
    var authProvider = props.authProvider,
      alternativeHeader = props.alternativeHeader,
      alternativeDescription = props.alternativeDescription;
    if (currentStep === Step.SendEmail) {
      return /*#__PURE__*/React.createElement(SendEmail, {
        email: email,
        isLoading: isLoading,
        errorMessage: errorMessage,
        authProvider: authProvider,
        onModalClose: closeMfa,
        clearError: clearErrorMessage,
        sendCodeToEmail: sendCodeToEmail,
        alternativeHeader: alternativeHeader,
        alternativeDescription: alternativeDescription
      });
    }
    return null;
  };
  var renderValidateCode = function renderValidateCode() {
    if (currentStep === Step.ValidateCode) {
      return /*#__PURE__*/React.createElement(ValidateCode, {
        email: email,
        mfaToken: mfaToken,
        isLoading: isLoading,
        onModalClose: closeMfa,
        errorMessage: errorMessage,
        returnToSendEmailStep: goBack,
        clearError: clearErrorMessage,
        validateCode: sendMfaValidationCode
      });
    }
    return null;
  };
  var component = /*#__PURE__*/React.createElement(React.Fragment, null, renderSendEmail(), renderValidateCode());
  if (!mfaToken) return null;
  if (props.noDialog) {
    return component;
  }
  return /*#__PURE__*/React.createElement(Popup, {
    size: "md",
    id: "popup",
    "aria-label": "Mfa modal",
    isOpen: isOpen,
    onClose: closeMfa,
    hideCloseButton: hideCloseButton,
    "data-test": 'mfa-by-email-modal',
    shouldCloseOnClickOutside: false
  }, component);
};
export default MfaByEmail;